/**
 * Handle mobile navigation
 */
const handleMobileNavigation = () => {
	$('.nav-trigger, .header__content-close').on('click', function(event) {
		$('.header__content').toggleClass('is--active');

		$('.nav-trigger').toggleClass('is--active');

		event.preventDefault();
	});
}

handleMobileNavigation();
